import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { H2, Section } from '../ui/Section';
import { CtaButton } from '../ui/CtaButton';
import { testimonials } from '../../data/content';
export function TestimonialsSection() {
  return <Section tone="light" data-id="element-312" data-mp="1rtuyxbmj99ju">
      <div className="mx-auto max-w-3xl text-center" data-id="element-313" data-mp="1mwkxexlvd7fn">
        <p className="font-display text-base font-bold uppercase text-accent-strong" data-id="element-314" data-mp="1mw1schhbidj1">What dental professionals are saying</p>
        <H2 className="mt-3" data-id="element-315" data-mp="1iswqmh52afvg">A More Organized Way to Study Implant Treatment Planning.</H2>
      </div>

      <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-316" data-mp="1dy9b37s1cvt0">
        {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 ring-1 ring-ink/10" data-id="element-317" data-mp="13xqjfqu8cb0j">
            <div className="flex items-center justify-between" data-id="element-318" data-mp="33auldqm78u5y">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-319" data-mp="33a1pjkos3p2l">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-320" data-mp="1t9n80dhekaj5" data-mpi={i} />)}
              </div>
              <QuoteIcon className="h-7 w-7 text-accent-strong/30" aria-hidden="true" data-id="element-321" data-mp="1y9rldun0kp55" />
            </div>
            <p className="mt-4 font-display text-lg font-extrabold leading-snug" data-id="element-322" data-mp="1jcr5qpi3kkn1">“{t.headline}”</p>
            <blockquote className="mt-3 text-base leading-relaxed text-ink/80" data-id="element-323" data-mp="1obbunsrwfhw6">“{t.quote}”</blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-324" data-mp="2c1fwbulj17kj">
              <img src={t.photo} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-accent" data-id="element-325" data-mp="2gzhg6hqs1ax2" />
              <div data-id="element-326" data-mp="229k06p303riy">
                <p className="font-bold leading-tight" data-id="element-327" data-mp="22a1tpdya3rn6">{t.name}</p>
                <p className="text-sm text-muted" data-id="element-328" data-mp="278d2rmgr1y4c">{t.role} · {t.country}</p>
              </div>
            </figcaption>
          </figure>)}
      </div>

      <div className="mt-12" data-id="element-329" data-mp="2zppfspv9pj8i">
        <CtaButton label="I want to study implantology with a clearer framework" note="Join them today · $27 USD" data-id="element-330" data-mp="2zpz4890nzic3" />
      </div>
    </Section>;
}